module.exports = __webpack_public_path__ + "img/135ne.ffb213f4.svg";